import { render, staticRenderFns } from "./dialogInformeComerciales.vue?vue&type=template&id=e2c47c6e"
import script from "./dialogInformeComerciales.vue?vue&type=script&lang=js"
export * from "./dialogInformeComerciales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports